export const logObject = (props) => {
  return {
    projectId: localStorage?.projectId ? localStorage?.projectId : "" || null,
    projectName: localStorage?.projectName
      ? localStorage?.projectName
      : "" || null,
    batchId: localStorage?.batchId ? localStorage?.batchId : "" || null,
    batchName: localStorage?.batchName ? localStorage?.batchName : "" || null,
    userId: localStorage?.userid ? localStorage?.userid : "" || null,
    userName: localStorage?.userName ? localStorage?.userName : "" || null,
    drugType: localStorage?.drugType ? localStorage?.drugType : "" || null,
    isActivity: props?.isActivity || false,
    extractionType: props?.extractionType, // template/freeform
    category: props?.category || null, // data , inputs , reject , resolve, range
    action: props?.action || null, // Apply Datatype, Add Column  , Delete Column and so on
    parameter: props?.parameter || null,
    rangeMin: props?.rangeMin || null,
    rangeMax: props?.rangeMax || null,
    pageNo: props?.pageNo === 0 ? props?.pageNo : props?.pageNo || null, // send only when cell containt change
    tagName: props?.tagName || null,
    fileNo: props?.fileNo === 0 ? props?.fileNo : props?.fileNo || null,
    coordinates: props?.coordinates || null,
    coordinatesValues: props?.coordinatesValues || null,
    dataType: props?.dataType || null,
    mbrName: props?.mbrName || null, // take it from be
    value: props?.value === 0 ? props?.value : props?.value || null, // send only when cell containt change
    document: props?.document || null, //  take it from be after validation contains op file path   check and remove and add it to batch level in header or footer
    userRole: localStorage?.userRole ? localStorage?.userRole : "" || null,
    dateTime: new Date() || null,
    rowColIndex: props?.rowColIndex || null, // row/col names/indexes
    remark: props?.remark || null,
    data: props?.data || null,
    processorRejected: props?.processorRejected || false,
    validatorRejected: props?.validatorRejected || false,
    investigationValidatorRejected:
      props?.investigationValidatorRejected || false,
    keyCoordinates: props?.keyCoordinates || null,
    keyCoordinatesValues: props?.keyCoordinatesValues || null,
    keyData: props?.keyData || null,
    templateTagName: props?.templateTagName || null,
  };
};
